module.exports = __webpack_public_path__ + "img/pill-grid-8x3-960w.64e7de0d.jpg";